document.addEventListener('DOMContentLoaded', function() {
    //sticky
    const stickyCartBar = document.querySelector('.sticky-cart-bar');
    const productForm = document.querySelector('.product-form');
  
    if (stickyCartBar && productForm) {
        window.addEventListener('scroll', function() {
            const formRect = productForm.getBoundingClientRect();
            if (formRect.bottom < 0) {
                stickyCartBar.classList.add('visible');
            } else {
                stickyCartBar.classList.remove('visible');
            }
        });
    }

    //scroll options
    const scrollWrapper = document.querySelector('.sticky-scroll-wrapper');
    const btnLeft = document.querySelector('.sticky-scroll-btn.left');
    const btnRight = document.querySelector('.sticky-scroll-btn.right');

    function updateButtons() {
        const scrollLeft = scrollWrapper.scrollLeft;
        const maxScrollLeft = scrollWrapper.scrollWidth - scrollWrapper.clientWidth;

        if (scrollLeft > 0) {
        btnLeft.style.display = 'flex';
        btnLeft.disabled = false;
        } else {
        btnLeft.style.display = 'none';
        btnLeft.disabled = true;
        }

        if (scrollLeft < maxScrollLeft - 1) {
        btnRight.style.display = 'flex';
        btnRight.disabled = false;
        } else {
        btnRight.style.display = 'none';
        btnRight.disabled = true;
        }
    }

    btnLeft.addEventListener('click', () => {
        scrollWrapper.scrollBy({ left: -150, behavior: 'smooth' });
    });

    btnRight.addEventListener('click', () => {
        scrollWrapper.scrollBy({ left: 150, behavior: 'smooth' });
    });

    scrollWrapper.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    setTimeout(updateButtons, 100);

    //change addto btn for mobile
    const scrollToBtn = document.querySelector('.product-form__submit.scrollto');
    if (scrollToBtn && productForm) {
        scrollToBtn.addEventListener('click', function (e) {
            e.preventDefault();
            productForm.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
            });
        });
    }

    //variants
    const variantsScript = document.getElementById('StickyProductVariants');
    let productVariants = [];

    if (variantsScript) {
        try {
            productVariants = JSON.parse(variantsScript.textContent);
        } catch (e) {
            console.error('Failed to parse variant JSON:', e);
        }
    }
    const form = document.querySelector('.sticky-cart-form');
    const radios = form.querySelectorAll('.sticky-cart-option-input');
    const variantIdInput = form.querySelector('input[name="id"]');

    function getSelectedOptions() {
        const selected = [];
        const fieldsets = form.querySelectorAll('.sticky-cart-option-values');
        fieldsets.forEach((fieldset) => {
            const checked = fieldset.querySelector('input:checked');
            if (checked) selected.push(checked.value);
        });
        return selected;
    }

    function findMatchingVariant() {
        const selectedOptions = getSelectedOptions();
        const matchedVariant = productVariants.find(v =>
        JSON.stringify(v.options) === JSON.stringify(selectedOptions)
        );
        if (matchedVariant) {
            variantIdInput.value = matchedVariant.id;

            const buyNowBtn = form.querySelector('.js-buy-now');
            if (buyNowBtn) {
            buyNowBtn.dataset.variantId = matchedVariant.id;
            }

        }
    }

    radios.forEach(radio => {
    radio.addEventListener('change', findMatchingVariant);
    });

    findMatchingVariant();

    //sync qty for sticky and product form
    const stickyQty = document.querySelector('.product-form-sticky .quantity__input');
    const mainQty = document.querySelector('.product-form .quantity__input');

    let syncing = false;

    function syncQty(sourceInput, targetInput) {
        if (syncing) return;
        syncing = true;

        const val = parseInt(sourceInput.value, 10);
        if (!isNaN(val)) {
        targetInput.value = val;
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncing = false;
    }

    stickyQty.addEventListener('change', () => {
        syncQty(stickyQty, mainQty);
    });

    mainQty.addEventListener('change', () => {
        syncQty(mainQty, stickyQty);
    });
});